export function useApiClients() {
  const { core, ibexa, brikke } = useRuntimeConfig().public

  const client = useOidcClient()

  const base = $fetch.create({
    async onRequest({ options }) {
      const token = client.getAccessToken()

      if (token) {
        options.headers.set("Authorization", `Bearer ${token}`)
      }
    },
  })

  return {
    ecommerce: base.create({
      baseURL: core.ecommerceApiBaseUrl,
    }),
    external: base.create({
      baseURL: core.externalApiBaseUrl,
    }),
    ibexa: base.create({
      baseURL: ibexa.apiUrl,
      headers: IBEXA_HEADERS,
    }),
    brikke: base.create({
      baseURL: brikke.apiUrl,
    }),
  }
}
